import {Control} from './Control.js';
import {Layers} from './Control.Layers.js';
import {Zoom} from './Control.Zoom.js';
import {Scale} from './Control.Scale.js';
import {Attribution} from './Control.Attribution.js';

Control.Layers = Layers;
Control.Zoom = Zoom;
Control.Scale = Scale;
Control.Attribution = Attribution;

export {Control};
